import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import type { ReactNode } from 'react';
import { useId } from 'react';

import { cn } from '~/lib/cn';

export interface RadioButtonGroupItemType {
  label?: string;
  labelComponent?: ReactNode;
  labelAlign?: 'center' | 'start';
  value: string;
}

interface RadioButtonGroupItemProps {
  item: RadioButtonGroupItemType;
  selected: boolean;
  className: string;
  selectedClassName: string;
}

export function RadioButtonGroupItem({
  item,
  selected,
  className,
  selectedClassName,
}: RadioButtonGroupItemProps) {
  const id = useId();
  const { label, labelComponent, labelAlign = 'center', value } = item;

  return (
    <label
      htmlFor={id}
      className={cn(
        'flex w-full cursor-pointer rounded-sm border-px px-md py-lg border-emphasis-subtle',
        {
          [selectedClassName]: selected,
          'items-center': labelAlign === 'center',
          '-inset-0 items-start': labelAlign === 'start',
        },
        className,
      )}
    >
      <RadixRadioGroup.Item className="p-2xs" value={value} id={id}>
        <div className="flex size-md items-center justify-center rounded-full border-px border-strong">
          <RadixRadioGroup.Indicator className="size-[10px] rounded-full bg-primary-default" />
        </div>
      </RadixRadioGroup.Item>
      {labelComponent ?? (
        <div className="px-md text-body-md text-default">{label}</div>
      )}
    </label>
  );
}

RadioButtonGroupItem.displayName = 'RadioButtonGroupItem';
